import React, { useState, setGlobal, getGlobal, useEffect } from 'reactn';
import {useParams} from 'react-router-dom';
import { Radio, Tabs, Row } from 'antd';
import LeftEar from './Ear/LeftEar';
import RightEar from './Ear/RightEar';
import LeftNose from './Nose/LeftNose';
import RightNose from './Nose/RightNose';
import OralCavityThroat from './OralCavity-Throat/OralCavityThroat';
import ThroatLarynxHypopharynx from './Throat-Larynx-Hypopharynx/ThroatLarynxHypopharynx';
import Thyroid from './Thyroid/Thyroid';
import NeckMass from './NeckMass/NeckMass';
import ParotidSubmandibularMass from './ParotidSubmandibularMass/ParotidSubmandibularMass';
import Ulcer from './Ulcer/Ulcer';
import { firestore, useFirestore } from 'reactfire';



const Examination = () => {

    let { appointmentId } = useParams();
    let firestore = useFirestore();

    const [location, setLocation] = useState('Ear');
    const [state, setState] = useState();

    const changeLocation = (event) => {
        setLocation(event.target.value);
    }


    useEffect(() => {
        if (!state) {
            getExaminations();
        }
    }, [state]);

    const getExaminations = () => {
        let records = [];
        firestore.collection("Examination").where("appointment_id", "==", appointmentId).get()
        .then((querySnapshot) => {
            querySnapshot.forEach((doc) => {
                records.push({data: doc.data(), id: doc.id});
            });
            setGlobal({examination_location: records.length > 0 ? records[0].data.examination_location : getGlobal().examination_location});
            setGlobal({examination_location_id: records.length > 0 ? records[0].id : null});
            setState({examination_location: records.length > 0 ? records[0].data.examination_location : getGlobal().examination_location});
        });
    }

    const documentHasSaved = () => {
        getExaminations();
    }


        const { TabPane } = Tabs;

        function earTabs(key) {
        // console.log(key);
        }

        
 

    return (
        <React.Fragment>
            <Radio.Group defaultValue={'Ear'} onChange={changeLocation} buttonStyle="solid" size="large">
                <Radio.Button value={'Ear'}>Ear</Radio.Button>
                <Radio.Button value={'Nose'}>Nose</Radio.Button>
                <Radio.Button value={'Oral Cavity/Throat'}>Oral Cavity/Throat</Radio.Button>
                <Radio.Button value={'ThroatLarynxHypopharynx'}>Throat/Larynx/Hypopharynx</Radio.Button>
                <Radio.Button value={'Thyroid'}>Thyroid</Radio.Button>
                <Radio.Button value={'NeckMass'}>Neck Mass</Radio.Button>
                <Radio.Button value={'ParotidSubmandibularMass'}>Parotid/Submandibular Mass</Radio.Button>
                <Radio.Button value={'Ulcer'}>Ulcer</Radio.Button>            
            </Radio.Group>

            {location === 'Ear' ? 
                <Tabs defaultActiveKey="1" onChange={earTabs}>
                    <TabPane tab="Left Ear" key="1">
                    <LeftEar hasSaved={documentHasSaved} examlocation={state && state.examination_location} />
                    </TabPane>
                    <TabPane tab="Right Ear" key="2">
                    <RightEar hasSaved={documentHasSaved} examlocation={state && state.examination_location} />
                    </TabPane>
                </Tabs>
            : ''
            }

            {location === 'Nose' ? 
                <Tabs defaultActiveKey="1">
                    <TabPane tab="Left Nose" key="1">
                    <LeftNose hasSaved={documentHasSaved} examlocation={state && state.examination_location} />
                    </TabPane>
                    <TabPane tab="Right Nose" key="2">
                    <RightNose hasSaved={documentHasSaved} examlocation={state && state.examination_location}/>
                    </TabPane>
                </Tabs>
            : ''
            }

            {location === 'Oral Cavity/Throat' ?
                <OralCavityThroat hasSaved={documentHasSaved} examlocation={state && state.examination_location}/>
            : ''
            }

            {location === 'ThroatLarynxHypopharynx' ?
                <ThroatLarynxHypopharynx hasSaved={documentHasSaved} examlocation={state && state.examination_location}/>
            : ''
            }

            {location === 'Thyroid' ?
                <Thyroid hasSaved={documentHasSaved} examlocation={state && state.examination_location}/>
            : ''
            }

            {location === 'NeckMass' ?
                <NeckMass hasSaved={documentHasSaved} examlocation={state && state.examination_location}/>
            : ''
            }

            {location === 'ParotidSubmandibularMass' ?
                <ParotidSubmandibularMass hasSaved={documentHasSaved} examlocation={state && state.examination_location}/>
            : ''
            }

            {location === 'Ulcer' ?
                <Ulcer hasSaved={documentHasSaved} examlocation={state && state.examination_location}/>
            : ''
            }


        </React.Fragment>
    );
}

export default Examination;
